import React from 'react';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';

// Import images (Update with actual paths)
import villaImage from '../assets/Villa/Untitled design (2).png';
import singleRoomImage from '../assets/Home/WhatsApp Image 2025-08-14 at 10.23.14.jpeg';
import familyRoomImage from '../assets/Home/WhatsApp Image 2025-08-14 at 10.23.13.jpeg';
import seaBathImage from '../assets/Villa/WhatsApp Image 2025-08-14 at 21.28.27-Photoroom.png';
import restuarantImage from '../assets/Villa//Untitled (10 x 5 cm).png';

const Villa = () => {
    const { t } = useTranslation();

    return (
        <section className="container my-5">
            {/* Villa Description and Image Section - Desktop (md and larger) */}
            <div className="row align-items-center hidden md:flex">
                {/* Left Side - Villa Description */}
                <div className="col-md-6 order-md-1 order-2 mt-4 md:mt-0">
                    <h1 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-10">
                        {t('villa.title')}
                    </h1>
                    <h3 className="text-gray-600 text-base sm:text-lg md:text-xl mb-4 md:mb-6 font-serif">
                        {t('villa.description1')}
                    </h3>
                    <h3 className="text-gray-600 text-base sm:text-lg md:text-xl mb-4 md:mb-6 font-serif">
                        {t('villa.description2')}
                    </h3>
                </div>

                {/* Right Side - Villa Image */}
                <div className="col-md-6 text-center order-md-2 order-1">
                    <img
                        src={villaImage}
                        alt={t('villa.imageAlt')}
                        className="img-fluid rounded-3xl shadow-lg w-auto h-[700px]"
                    />
                </div>
            </div>

            {/* Villa Description and Image Section - Mobile (sm) */}
            <div className="flex flex-col items-center text-center md:hidden">
                <h1 className="text-[#114131] text-3xl sm:text-3xl font-bold mb-4 sm:mb-6">
                    {t('villa.title')}
                </h1>
                <div className="w-full max-w-[400px] mb-4 sm:mb-6">
                    <img
                        src={villaImage}
                        alt={t('villa.imageAlt')}
                        className="img-fluid rounded-3xl shadow-lg w-auto h-[400px]"
                    />
                </div>
                <h3 className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 max-w-[90%] font-serif">
                    {t('villa.description1')}
                </h3>
                <h3 className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 max-w-[90%] font-serif">
                    {t('villa.description2')}
                </h3>
            </div>



            {/* Our Rooms Section - Desktop (md and larger) */}
            <section className="text-center my-6 sm:my-8 md:my-10 hidden md:block">
                <h2 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 md:mb-8">
                    {t('villa.roomsTitle')}
                </h2>
                <h3 className="text-[#E6A71A] text-base sm:text-lg md:text-xl mb-4 sm:mb-6 md:mb-8 w-11/12 md:w-3/4 mx-auto font-serif">
                    {t('villa.roomsDescription')}
                </h3>

                {/* Room Cards */}
                <div className="row justify-content-center">
                    {/* Single Room */}
                    <div className="col-md-6 col-lg-5 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-lg max-w-[500px] mx-auto">
                            <div className="relative">
                                <img
                                    src={singleRoomImage}
                                    alt={t('villa.singleRoomAlt')}
                                    className="w-full h-[350px] object-cover transition-transform duration-300 ease-in-out hover:scale-105"
                                />
                                <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white py-3">
                                    <h3 className="mb-0 text-base sm:text-lg md:text-xl">{t('villa.singleRoomTitle')}</h3>
                                </div>
                            </div>
                            <div className="p-4 sm:p-6 text-center">
                                <a
                                    href="/deluxe-double-rooms"
                                    className="bg-[#114131] hover:bg-[#E6A71A] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-md text-sm sm:text-base md:text-lg font-semibold transition-colors duration-300"
                                >
                                    {t('villa.viewDetails')}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Family Room */}
                    <div className="col-md-6 col-lg-5 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-lg max-w-[500px] mx-auto">
                            <div className="relative">
                                <img
                                    src={familyRoomImage}
                                    alt={t('villa.familyRoomAlt')}
                                    className="w-full h-[370px] object-cover transition-transform duration-300 ease-in-out hover:scale-105"
                                />
                                <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white py-3">
                                    <h3 className="mb-0 text-base sm:text-lg md:text-xl">{t('villa.familyRoomTitle')}</h3>
                                </div>
                            </div>
                            <div className="p-4 sm:p-6 text-center">
                                <a
                                    href="/deluxe-double-room-sea-view"
                                    className="bg-[#114131] hover:bg-[#E6A71A] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-md text-sm sm:text-base md:text-lg font-semibold transition-colors duration-300"
                                >
                                    {t('villa.viewDetails')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Rooms Section - Mobile (sm) */}
            <section className="text-center my-6 sm:my-8 block md:hidden">
                <h2 className="text-[#114131] text-3xl sm:text-3xl font-bold mb-4 sm:mb-6">
                    {t('villa.roomsTitle')}
                </h2>
                <h3 className="text-[#E6A71A] text-base sm:text-lg mb-4 sm:mb-6 w-11/12 mx-auto font-serif">
                    {t('villa.roomsDescription')}
                </h3>

                {/* Room Cards */}
                <div className="flex flex-col gap-4 sm:gap-6 items-center">
                    {/* Single Room */}
                    <div className="w-full max-w-[400px]">
                        <div className="border-0 shadow-lg overflow-hidden rounded-lg">
                            <div className="relative">
                                <img
                                    src={singleRoomImage}
                                    alt={t('villa.singleRoomAlt')}
                                    className="w-full h-[250px] sm:h-[300px] object-cover"
                                />
                                <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white py-2 sm:py-3">
                                    <h3 className="mb-0 text-base sm:text-lg">{t('villa.singleRoomTitle')}</h3>
                                </div>
                            </div>
                            <div className="p-3 sm:p-4 text-center">
                                <a
                                    href="/deluxe-double-rooms"
                                    className="bg-[#114131] hover:bg-[#E6A71A] text-white px-4 sm:px-5 py-2 rounded-md text-sm sm:text-base font-semibold transition-colors duration-300"
                                >
                                    {t('villa.viewDetails')}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Family Room */}
                    <div className="w-full max-w-[400px]">
                        <div className="border-0 shadow-lg overflow-hidden rounded-lg">
                            <div className="relative">
                                <img
                                    src={familyRoomImage}
                                    alt={t('villa.familyRoomAlt')}
                                    className="w-full h-[250px] sm:h-[300px] object-cover"
                                />
                                <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white py-2 sm:py-3">
                                    <h3 className="mb-0 text-base sm:text-lg">{t('villa.familyRoomTitle')}</h3>
                                </div>
                            </div>
                            <div className="p-3 sm:p-4 text-center">
                                <a
                                    href="/deluxe-double-room-sea-view"
                                    className="bg-[#114131] hover:bg-[#E6A71A] text-white px-4 sm:px-5 py-2 rounded-md text-sm sm:text-base font-semibold transition-colors duration-300"
                                >
                                    {t('villa.viewDetails')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sea Bath Near the Villa Section - Desktop (md and larger) */}
            <section className="my-6 sm:my-8 md:my-10 hidden md:flex">
                <div className="row align-items-center">
                    {/* Left Side - Image */}
                    <div className="col-md-6 text-center order-md-1 order-2 mt-4 md:mt-0">
                        <img
                            src={seaBathImage}
                            alt={t('villa.seaBathAlt')}
                            className="img-fluid rounded-3xl shadow-lg w-full"
                        />
                    </div>

                    {/* Right Side - Description */}
                    <div className="col-md-6 order-md-2 order-1">
                        <h2 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-10">
                            {t('villa.seaBathTitle')}
                        </h2>
                        <h3 className="text-gray-600 text-base sm:text-lg md:text-xl mb-4 md:mb-6 font-serif">
                            {t('villa.seaBathDescription1')}
                        </h3>
                        <h3 className="text-gray-600 text-base sm:text-lg md:text-xl mb-4 md:mb-6 font-serif">
                            {t('villa.seaBathDescription2')}
                        </h3>
                    </div>
                </div>
            </section>

            {/* Sea Bath Near the Villa Section - Mobile (sm) */}
            <section className="my-6 sm:my-8 block md:hidden">
                <div className="flex flex-col items-center text-center">
                    <h2 className="text-[#114131] text-3xl sm:text-3xl font-bold mb-4 sm:mb-6">
                        {t('villa.seaBathTitle')}
                    </h2>
                    <div className="w-full max-w-[400px] mb-4 sm:mb-6">
                        <img
                            src={seaBathImage}
                            alt={t('villa.seaBathAlt')}
                            className="img-fluid rounded-3xl shadow-lg w-full"
                        />
                    </div>
                    <h3 className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 max-w-[90%] font-serif">
                        {t('villa.seaBathDescription1')}
                    </h3>
                    <h3 className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 max-w-[90%] font-serif">
                        {t('villa.seaBathDescription2')}
                    </h3>
                </div>
            </section>

            {/* Restaurant Section - Desktop (md and larger) */}
            <div className="row align-items-center hidden md:flex">
                {/* Left Side - Description */}
                <div className="col-md-6 order-md-1 order-2 mt-4 md:mt-0">
                    <h1 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-10">
                        {t('villa.restaurantTitle')}
                    </h1>
                    <h3 className="text-gray-600 text-base sm:text-lg md:text-xl mb-4 md:mb-6 font-serif">
                        {t('villa.restaurantDescription1')}
                    </h3>
                    <h3 className="text-gray-600 text-base sm:text-lg md:text-xl mb-4 md:mb-6 font-serif">
                        {t('villa.restaurantDescription2')}
                    </h3>
                </div>

                {/* Right Side - Restaurant Image */}
                <div className="col-md-6 text-center order-md-2 order-1">
                    <img
                        src={restuarantImage}
                        alt={t('villa.restaurantImageAlt')}
                        className="img-fluid rounded-3xl shadow-lg w-full"
                    />
                </div>
            </div>

            {/* Restaurant Section - Mobile (sm) */}
            <div className="flex flex-col items-center text-center md:hidden">
                <h1 className="text-[#114131] text-3xl sm:text-3xl font-bold mb-4 sm:mb-6">
                    {t('villa.restaurantTitle')}
                </h1>
                <div className="w-full max-w-[400px] mb-4 sm:mb-6">
                    <img
                        src={restuarantImage}
                        alt={t('villa.restaurantImageAlt')}
                        className="img-fluid rounded-3xl shadow-lg w-full"
                    />
                </div>
                <h3 className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 max-w-[90%] font-serif">
                    {t('villa.restaurantDescription1')}
                </h3>
                <h3 className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 max-w-[90%] font-serif">
                    {t('villa.restaurantDescription2')}
                </h3>
            </div>
        </section>
    );
};

export default Villa;